import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { jarvisOnestockDashboardConstants } from "./jarvisOnestockDashboardConstants";


const initialState = {
    dashboardStats: {},
    dashboardstatsv2: {},
    dashboardReveal: {},
    loading: {
        dashboardstatsv2: 0,
        dashboardStats: 0,
        dashboardReveal: 0,
    },
};

export const jarvisOnestockDashboardReducer = persistReducer(
    {
        storage,
        key: "onestockDashboard",
        whitelist: [],
    },

    (state = initialState, { type, payload }) => {
        switch (type) {
            case jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_STATS_REQUEST: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        dashboardStats: 1,
                    },
                    dashboardStats: state.dashboardStats,
                };
            }

            case jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_STATS_RESPONSE: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        dashboardStats: 0,
                    },
                    dashboardStats: payload,
                };
            }

            case jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_REVEAL_REQUEST: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        dashboardReveal: 1,
                    },
                    dashboardReveal: state.dashboardReveal,
                };
            }

            case jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_REVEAL_RESPONSE: {
                console.log("jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_REVEAL_RESPONSE");
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        dashboardReveal: 0,
                    },
                    dashboardReveal: payload,
                };
            }

            case jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_STATSV2_REQUEST: {
                console.log("jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_STATSV2_REQUEST");
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        dashboardstatsv2: 1,
                    },
                    dashboardstatsv2: state.dashboardstatsv2,
                };
            }

            case jarvisOnestockDashboardConstants.JARVIS_ONESTOCK_DASHBOARD_STATSV2_RESPONSE: {
                return {
                    ...state,
                    loading: {
                        ...state.loading,
                        dashboardstatsv2: 0,
                    },
                    dashboardstatsv2: payload,
                };
            }

            default:
                return state;
        }
    }
);
